export default __webpack_public_path__ + "static/media/subscribe_image.d3e51fb2.png";